export const Terms = () => {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16" data-testid="terms-page">
      <h1 className="mb-2 font-heading text-4xl font-bold text-white">Terms of Service</h1>
      <p className="mb-10 text-sm text-slate-500">Last updated: September 2026</p>

      <div className="space-y-8 text-slate-300">
        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">1. Acceptance of Terms</h2>
          <p>
            By creating an account or using BrandSignal ("the Service"), you agree to these Terms of Service, our
            <a href="/privacy" className="text-openai-cyan hover:underline"> Privacy Policy</a>, and our
            <a href="/ai-transparency" className="text-openai-cyan hover:underline"> AI Transparency Disclosure</a>.
            If you do not agree, do not use the Service.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">2. Description of Service</h2>
          <p>
            BrandSignal audits how AI models (OpenAI, Anthropic Claude, Google Gemini, Perplexity) describe a
            brand, and produces AI-generated Visibility Scores, Hallucination Warnings, Truth Statements,
            Competitor Deep-Dives, Metadata Audits, and Reputation Scorecards. All outputs are AI-generated - see
            our AI Transparency Disclosure for full detail.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">3. Accounts &amp; Security</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials and for all
            activity under your account. Notify us immediately of any unauthorized use.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">4. Subscription Tiers &amp; Payment</h2>
          <p>
            BrandSignal offers a free Pulse Check and paid tiers (Fix Manual $99, Truth Verify $299, Sovereign
            Agency $799). Payments are processed via Stripe; BrandSignal does not store your card details. Paid
            tiers unlock the features described at checkout. All sales are for digital intelligence reports and,
            except where required by law, are final.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">5. Acceptable Use</h2>
          <p>
            You may not use the Service to harass, defame, or generate false statements about a real person or
            entity to be published as fact, or to attempt to reverse-engineer, scrape, or overload the Service.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">6. Intellectual Property</h2>
          <p>
            BrandSignal retains all rights to the Service, its branding, and its underlying technology. You retain
            ownership of the brand name and materials you submit for audit; you grant BrandSignal a license to
            process them solely to generate your reports.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">7. AI-Generated Content Disclaimer</h2>
          <p>
            All reports, scores, warnings, Truth Statements, and BrandSignal Buddy chat responses are AI-generated
            and provided "as is" without warranty of accuracy, completeness, or fitness for a particular purpose.
            See our <a href="/ai-transparency" className="text-openai-cyan hover:underline">AI Transparency
            Disclosure</a> for full detail. You are solely responsible for verifying any output before relying on
            it or publishing it externally.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, BrandSignal shall not be liable for any indirect, incidental,
            special, consequential, or punitive damages, or any loss of profits or revenue, arising from your use
            of the Service or reliance on any AI-generated output, even if advised of the possibility of such
            damages. BrandSignal's total liability for any claim shall not exceed the amount you paid for the
            Service in the 3 months preceding the claim.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">9. Termination</h2>
          <p>
            We may suspend or terminate your access for violation of these Terms. You may stop using the Service
            and request account deletion at any time via our Support portal.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">10. Changes to These Terms</h2>
          <p>
            We may update these Terms from time to time. Continued use of the Service after a change constitutes
            acceptance of the revised Terms.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-heading text-lg font-bold text-sovereign">11. Contact</h2>
          <p>
            Questions about these Terms? Reach the Sovereign Directorate via our
            <a href="/support" className="text-openai-cyan hover:underline"> Support &amp; Feedback</a> portal.
          </p>
        </section>
      </div>
    </div>
  );
};
